// Written by scripts/generate-series-og-images.mjs during prebuild. Do not edit.
// slug -> content hash of the series OG card. The hash is appended as `?v=` so a
// changed card gets a new URL (cards are cached for a year, see public/_headers).
export const seriesOgHashes = {
  "shared-tenant-content-boundary": "9bdf8a5f3153",
  "copilot-agent-governance": "75509436c34b",
  "copilot-readiness-sharepoint": "047a6e7cf725",
  "copilot-waves": "ed5cee13c225",
  "cyber-action-month-2026": "b2f32b24b02d",
  "microsoft-365-local": "c5d85e9e2669"
};
